import {createClient} from "@supabase/supabase-js";

const supabaseUrl = 'https://mhlhkccoqkggfnmboabz.supabase.co';
const supabaseKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im1obGhrY2NvcWtnZ2ZubWJvYWJ6Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3MzgxMTA5MDksImV4cCI6MjA1MzY4NjkwOX0.GdZD-IC7gm-cEV3eF15c_yOxowU1qIWSktNJzLpim28';
export const supabase = createClient(supabaseUrl, supabaseKey);

